import { render } from "./EditQuotationPage.vue?vue&type=template&id=17dd09f2&ts=true"
import script from "./EditQuotationPage.vue?vue&type=script&lang=ts"
export * from "./EditQuotationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__